export class BusinessDaysApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCompanyBusinessDays({ companyId }) {
    return this.#http.get(`/api/companies/${companyId}`, {
      params: {
        include: 'businessschedule',
      },
    });
  }

  async updateCompanyBusinessDays({ companyId, data }) {
    return this.#http.put(`/api/companies/${companyId}/business-schedule`, data);
  }

  async getPotentialBusinessDays() {
    return this.#http.get('/api/potential-business-holidays');
  }
}
